export default {
	'sign-in': '',
	username: '',
	password: '',
}